export const FAQ_URL = "faq";
export const faqByIdUrl = (id) => `faq/${id}`;
export const faqBySlugUrl = (slug) => `faq/slug/${slug}`;
export const faqByPageTypeUrl = (pageType) => `faq/page-type/${pageType}`;
export const faqItemUrl = (id) => `faq/${id}/item`;
export const faqItemByIndexUrl = (id, index) => `faq/${id}/item/${index}`;
